import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { findAllImage, findEntityData, findImage } from "../../api/apiService";
const FullServiceSolutions = () => {
    const [section1, setSection1] = useState();
    const [imageUrls, setImageUrls] = useState([]);
    const findData = async () => {
        const res = await findEntityData("sss_about_full_service_solutions");
        setSection1(res?.data?.[0]);
    };

    const renderImage = async (id) => {
        if (!id) return null;
        const res = await findImage(id);
        return res?.data?.url;
    };
    const renderAllImage = async (id) => {
        if (!id) return [];
        const idArray = Array.isArray(id) ? id : [id];
        const idsParam = idArray.join(",");
        const res = await findAllImage(idsParam);
        return res?.data?.[0]?.data || [];
    };
    useEffect(() => {
        findData();
    }, []);

    useEffect(() => {
        const fetchImages = async () => {
            if (!section1?.data) return;
            const urls = await renderAllImage(section1.data.map(item => item.icon));
            setImageUrls(urls);
        };

        fetchImages();
    }, [section1]);
    return (
        <div className="max-w-5xl mx-auto mb-16">
            <h2
                className="text-xl font-semibold mb-6"
                data-aos="zoom-in"
                data-aos-duration="800"
                data-aos-easing="ease-out"
            >
                {section1?.heading}
            </h2>
            <p className="text-md text-[#56453F] pb-10">
                {section1?.content}
            </p>

            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 place-items-center sm:place-items-stretch">
                {section1?.data?.map((service, index) => (
                    <Link
                        key={index}
                        to={service?.redirectPath}
                        className="rounded-2xl p-8 flex flex-col items-center md:items-start text-center md:text-left 
                       border-2 border-white justify-between w-full h-auto md:h-64"
                        data-aos="flip-left"
                        data-aos-duration="1000"
                        data-aos-easing="ease-out-cubic"
                        style={{
                            background:
                                "linear-gradient(to bottom right, rgba(240,240,229,0) 35%, rgba(255,255,255,1) 50%, rgba(240,240,229,0) 65%)",
                        }}
                    >
                        <img
                            src={imageUrls[index]}
                            alt={service.title}
                            className="w-12 h-12 mb-2 mx-auto md:mx-0"
                        />
                        <h3 className="font-semibold text-[#56453F]">{service.title}</h3>
                        <p className="text-sm text-[#56453F] leading-relaxed">
                            {service.description}
                        </p>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default FullServiceSolutions
